export class Microsoft365UserRestoreData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workloads",
            "baseName": "workloads",
            "type": "Array<Microsoft365RestoreWorkload>",
            "format": ""
        },
        {
            "name": "everyWorkload",
            "baseName": "everyWorkload",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365UserRestoreData.attributeTypeMap;
    }
    constructor() {
    }
}
